export default __webpack_public_path__ + "static/code-nation-logo-6b1b26f34aa37a48ac086ab2340456a2.png";